'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils2.getLog)('[CongressRooms]');

// 1. (Optional) Select departure (by either using a calendar or a list)
// 2. Select room
// 3. Repeat. May select rooms from different departures.
// Selecting deprature is what makes this different from normal room selection.
//
// Data model for cabin assignment:
// Each room (product, NOT reservation product line) has array of checkboxes,
//  PassengerCheckboxes[0-indexed room number][0-indexed passenger number]
// This is kept in sync with actual product lines.

var WinresReservationCongressRoomsController = function () {
    function WinresReservationCongressRoomsController($scope, $rootScope, $filter, productService, departureService, reservationService, localizationService, cancelService, $location, $timeout) {
        _classCallCheck(this, WinresReservationCongressRoomsController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$location = $location;
        this.$timeout = $timeout;
        this.status = [];
        $scope._ = _;
        this.departureService = departureService;
        this.reservationService = reservationService;
        this.productService = productService;
        this.localizationService = localizationService;
        this.cancelService = cancelService;
        this.selectedMapId = 0;
        this.loading = 0;
        this.state = 'initial';
    }

    _createClass(WinresReservationCongressRoomsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var defaultSettings = {
                HideLargerRooms: false
            };
            this.reservationService.getSettingsForCongressRooms().then(function (settings) {
                if (!settings) {
                    log.error('Failed to retrieve settings. Using defaults.');
                    settings = {};
                }
                _this.initWithSettings(Object.assign({}, defaultSettings, settings));
            });
        }
    }, {
        key: 'initWithSettings',
        value: function initWithSettings(settings) {
            var _this2 = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Products
            // getContext().DestinationCode
            // getContext().SelectedDeparture
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().NumInfants
            // getContext().DepartureDate
            // getContext().ArrivalDate2
            // getContext().Passengers
            // getPassengerDisplayNames()
            // findProductLineByProduct

            // Set:
            // getContext().Products
            // getContext().SelectedDeparture
            // setReservationComponentErrors()

            this.settings = settings;
            log('Settings:', this.settings);

            this.data = this.winresReservationContext.getContext();

            // Use clonedeep here so we see Products as it was when logged, not how it is later
            log('Existing product lines on init:', _.cloneDeep(this.data.Products));

            this.hasGoogle = 'google' in window && (typeof google === 'undefined' ? 'undefined' : _typeof(google)) === 'object' && _typeof(google.maps) === 'object';

            if (this.departureMode != 'show-all') {
                // When departure changes, fetch room products.
                this.$scope.$watch('$ctrl.data.SelectedDeparture', function () {
                    _this2.fetchRoomProducts(true);
                });
            }

            // Update hotel rooms
            this.$scope.$on('number-of-people-change', function () {
                return _this2.fetchRoomProducts(true);
            });

            // this.$scope.$watch(() => this.data.Products, () => {
            //    var isCabin = _.some(this.data.Products,
            //                         p => (p.Product.DestinationInfo.ProductType == 'HY'));
            //     if(isCabin==true)
            //         this.mode = 'HY';
            // }, true);

            this.$scope.$watch('$ctrl.data.Passengers', function () {
                return _this2.initializePassengerData();
            }, true);

            this.$scope.$watchGroup(['$ctrl.data.NumAdults', '$ctrl.data.NumChildren', '$ctrl.data.NumInfants'], function () {
                return _this2.initializePassengerData();
            });

            // Validate on product add and product remove.
            this.$scope.$watchCollection('$ctrl.data.Products', function () {
                return _this2.validate();
            });

            // Validate on SelectedDeparture change to fix no rooms assignment validation
            this.$scope.$watchCollection('$ctrl.data.SelectedDeparture', function () {
                return _this2.validate();
            });

            // Translations become available, i.e. Passenger #1 texts can be
            // displayed.
            this.$scope.$on('i18nextLanguageChange', function () {
                return _this2.initializePassengerData();
            });

            // Fetch departures in modes where accommodation selection controls
            // current departure (i.e. K&K, not 'normal' package reservations)
            // In K&K rooms may be selected from multiple departures.
            if (this.departureMode == 'show-all' || this.departureMode == 'dropdown') {

                if (this.departureCodes != null) {
                    var departureCodes = this.departureCodes.split(",");
                }

                this.departureService.searchReservableItems({
                    'DestinationCodes': departureCodes || [this.data.DestinationCode],
                    'Limit': 100
                },
                /*withReserveLink=*/false, // Do not require Intres to be installed
                this.localizationService.getLanguage()).then(function (results) {
                    _this2.departures = results.Results;
                    _.each(_this2.departures, function (departure) {
                        // For use in ngModel / ngOptions
                        departure.Key = departure.Departure.DestinationCode + '#' + departure.Departure.DepartureDate + '#' + departure.Departure.ArrivalDate2;

                        departure.Title = (0, _utils.formatDateRange)(departure.Departure.DepartureDate, departure.Departure.ArrivalDate2);
                    });
                    if (_this2.departureMode == 'show-all') {
                        if (!_this2.Hotels) _this2.Hotels = [];
                        _.each(_this2.departures, function (dep) {
                            _this2.data.SelectedDeparture = _.find(_this2.departures, function (o) {
                                return o.Departure.DestinationCode + '#' + o.Departure.DepartureDate + '#' + o.Departure.ArrivalDate2 == dep.Key;
                            }).Departure;
                            _this2.departureKey = _this2.data.SelectedDeparture.DestinationCode + '#' + _this2.data.SelectedDeparture.DepartureDate + '#' + _this2.data.SelectedDeparture.ArrivalDate2;
                            _this2.fetchRoomProducts(false);
                        });
                    }
                    if (_this2.departures && _this2.departures.length && !_this2.data.SelectedDeparture) {
                        _this2.data.SelectedDeparture = _this2.departures[0].Departure;
                    }
                });
            }

            // Initialize and watch the departure selection model for dropdown.
            // Cannot simply use the departure object as a model, since objects
            // compare for equality only if they are the same object instance. This
            // would not work if the data is loaded from SessionStorage.
            if (this.departureMode == 'dropdown') {
                // Update departure in reservation session based on dropdown
                this.$scope.$watch('$ctrl.departureKey', function () {
                    if (_this2.departureKey && _this2.departures) {
                        // console.log(this.departures);
                        _this2.data.SelectedDeparture = _.find(_this2.departures, function (o) {
                            return o.Departure.DestinationCode + '#' + o.Departure.DepartureDate + '#' + o.Departure.ArrivalDate2 == _this2.departureKey;
                        }).Departure;
                        console.log("DEPARTURE CHANGE!", _this2.data.SelectedDeparture);
                    }
                });

                // Update selected departure in dropdown.
                this.$scope.$watch('$ctrl.data.SelectedDeparture', function () {
                    if (_this2.data.SelectedDeparture) {
                        _this2.departureKey = _this2.data.SelectedDeparture.DestinationCode + '#' + _this2.data.SelectedDeparture.DepartureDate + '#' + _this2.data.SelectedDeparture.ArrivalDate2;
                    } else {
                        _this2.departureKey = null;
                    }
                });
            }

            // WinresReservationMap.
            // When all markers have spawned, show mini map icon.
            this.$scope.$on("show-map-icon", function () {
                return _this2.showMapIcon = true;
            });

            // FIXME
            // Varaa matka scroll.
            this.$rootScope.scrollToTabs = function () {
                var tab = document.getElementsByTagName("winres-reservation-shopping-tabs")[0];
                if (tab) {
                    //window.scrollTo({ top: tab.offsetHeight + tab.offsetTop - 700, behavior: "smooth" });
                    var oldPadding = tab.style.padding;
                    tab.style.padding = window.innerHeight - 220 + "px"; // add scroll height.
                    tab.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                    tab.style.padding = oldPadding;
                }
            };

            // FIXME
            if (document.cookie.indexOf("tab=1") > -1) {
                this.scrollToTabs();
            }
        }
    }, {
        key: 'showMapForRoom',
        value: function showMapForRoom(departure, index) {
            var _this3 = this;

            var clickOutsideMap = function clickOutsideMap(event) {
                var target = event.target;
                if (_this3.firstClick && target.parentNode.parentNode.classList.value != "gm-style" && target.localName == "div" && target.offsetParent.classList.value != "gm-style-iw") {
                    // Is not map.
                    // Hide map.
                    document.getElementById("hotel-map").style.bottom = "99999px";

                    document.removeEventListener("click", clickOutsideMap);
                    _this3.hotelMap = false;

                    // Angular does not digest this click listener.
                    // Used to update $ctrl.hotelMap to template.
                    _this3.$scope.$apply();
                } else _this3.firstClick = true;
            };
            document.removeEventListener("click", clickOutsideMap);

            if (departure) {
                if (this.hotelMap === departure) {
                    this.hotelMap = null;

                    // Hide map.
                    document.getElementById("hotel-map").style.bottom = "99999px";
                } else {
                    // Show map.
                    document.getElementById("hotel-map").style.bottom = "inherit";

                    document.addEventListener("click", clickOutsideMap);
                    this.firstClick = false;

                    var selectedDeparture;

                    _.each(departure.Products, function (product) {
                        if (product.DestinationInfo.DestinationCode === _this3.data.SelectedDeparture.DestinationCode) selectedDeparture = product;
                    });

                    if (selectedDeparture && selectedDeparture.DestinationInfo && selectedDeparture.DestinationInfo.Latitude) {
                        this.$rootScope.$broadcast("setLatLng", {
                            lat: selectedDeparture.DestinationInfo.Latitude,
                            lng: selectedDeparture.DestinationInfo.Longitude,
                            zoom: 16,
                            selectedMapId: index
                        });
                    }
                    this.hotelMap = departure;
                }
            }
        }

        // Returns the total number of beds in rooms in shopping cart
        // (not including extra beds)

    }, {
        key: 'getUsedCapacity',
        value: function getUsedCapacity() {
            var capacity = 0;
            _.each(this.data.Products, function (p) {
                if (p.Product.DestinationInfo.ProductType == 'HY' || p.Product.DestinationInfo.ProductType == 'HU') {
                    capacity += p.Amount * p.Product.DestinationInfo.Beds;
                }
            });
            return capacity;
        }

        // Lowest default price is displayed for each hotel (producer). This is the
        // lowest room price available.

    }, {
        key: 'lowestPrice',
        value: function lowestPrice(hotel) {
            var lowest = hotel.Products[0].Price;
            _.each(hotel.Products, function (room) {
                if (room.Price < lowest) {
                    lowest = room.Price;
                }
            });
            return lowest;
        }

        // Actual price of the rooms with user selections

    }, {
        key: 'selectedHotelPrice',
        value: function selectedHotelPrice(hotel) {
            var _this4 = this;

            try {
                return _.sumBy(hotel.Products, function (room) {
                    return _this4.selectedRoomPrice(room);
                });
            } catch (e) {
                return null;
            }
        }
    }, {
        key: 'possiblePendingRoomPrice',
        value: function possiblePendingRoomPrice(room) {
            try {
                var line = this.winresReservationContext.findProductLineByProduct(room);
                if (line) {
                    return line.X_Price;
                }
            } catch (e) {
                log.warn('Failed to get pending price for room:', room, e);
            }
            return undefined;
        }
    }, {
        key: 'selectedRoomPriceNoExcept',
        value: function selectedRoomPriceNoExcept(room) {
            try {
                return this.selectedRoomPrice(room);
            } catch (e) {
                return null;
            }
        }

        // Actual price of a single room type with user selections

    }, {
        key: 'selectedRoomPrice',
        value: function selectedRoomPrice(room) {
            var sum = 0;
            var productLine = this.winresReservationContext.findProductLineByProduct(room);
            if (!productLine) {
                return null;
            }
            if (productLine.TotalPrice === undefined || productLine.TotalPrice === null) {
                throw 'Error - pricing not complete.';
            }
            return productLine.TotalPrice;
        }

        // Actual single supplement price

    }, {
        key: 'selectedRoomSingleSupplementPrice',
        value: function selectedRoomSingleSupplementPrice(room) {
            try {
                return this.singleSupplementPrice(room);
            } catch (e) {
                return null;
            }
        }

        // Actual price of single supplement with user selections

    }, {
        key: 'singleSupplementPrice',
        value: function singleSupplementPrice(room) {
            var productLine = this.winresReservationContext.findProductLineByProduct(room);

            if (!productLine) {
                return null;
            }

            return productLine.SingleSupplement;
        }

        //only for testing, ng-click in h2

    }, {
        key: 'thisdata',
        value: function thisdata() {
            console.info(this.data);
        }

        // Returns array with all available options for number of rooms.

    }, {
        key: 'getDropdownRange',
        value: function getDropdownRange(room) {
            var numPassengers = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
            if (this.disallowExtraOccupancy === 'true') {
                var a = [];
                var b;
                for (var i = 0; i <= this.data.NumAdults / room.DestinationInfo.Beds; i++) {
                    if (this.data.NumAdults - this.getUsedCapacity() < i * room.DestinationInfo.Beds && room.Amount < i) {
                        break;
                    }
                    a.push(i);
                }
                b = a.length;
                a.push(b);
                return a;
            } else {
                return _.range(0, Math.max(numPassengers, 10, room.Amount));
            }
        }
        // Returns array with all available options for number of rooms. Works bit differently than the other one

    }, {
        key: 'getDropdownRange2',
        value: function getDropdownRange2(room) {
            var a = [];
            for (var i = 0; i <= this.data.NumAdults; i++) {
                if (i > room.Capacity) {
                    break;
                }
                a.push(i);
            }
            return a;
        }
    }, {
        key: 'getSecretPrice',
        value: function getSecretPrice() {

            var roomPrice = room.price;
            var totalPrice = 0;
        }

        // Overwrite: if false, results are appended to the list of products, not
        // replaced. This is used when multiple departures are shown simultaneously
        // (in K&K where users may reserve accommodations for different days within
        //  the same reservation)

    }, {
        key: 'fetchRoomProducts',
        value: function fetchRoomProducts(overwrite) {
            var _this5 = this;

            // Push all passengers in one array
            this.passengers = [this.data.Customer];
            this.passengers = this.passengers.concat(this.data.Passengers);
            this.passengers.splice(1, 1);
            this.state = 'loading';

            if (this.listOnly === 'true' && this.data.SelectedDeparture && this.data.SelectedDeparture.IsAccommodations) {
                var q = this.departureService.getDepartureAccommodations(this.data.DestinationCode, this.data.SelectedDeparture.DepartureDate, this.data.SelectedDeparture.ArrivalDate2, this.winresReservationContext.Params.StopID);
                q.then(function (result) {
                    _this5.state = 'ready';

                    var hotels = _.map(result.Producers, function (producer) {
                        var accs = _.filter(result.Accommodations, function (acc) {
                            return acc.Producer == producer.Number;
                        });

                        var products = _.map(accs, function (acc) {
                            return {
                                BeginDate: acc.BeginDate,
                                EndDate: acc.EndDate,
                                Price: acc.Pricing.Price,
                                DestinationInfo: {
                                    DestinationCode: acc.DestCode,
                                    ProductCode: acc.ProdCode,
                                    ProductName: acc.ProdName,
                                    ProductType: acc.ProdType
                                },
                                noAmount: true,
                                priceError: _.includes(acc.Blockers, 'PriceError'),
                                blocked: _.size(acc.Blockers) > 0,
                                showWithMessage: _this5.getBlockerMessage(acc.Blockers)
                            };
                        });

                        // Filter out products that are blocked and not configured to be shown with a message.
                        products = _.filter(products, function (p) {
                            return !p.blocked || p.showWithMessage;
                        });

                        return {
                            activeImage: 0,
                            displayNotes: false,
                            Producer: _.assign({}, producer, { Images: _.map(producer.Images, function (img) {
                                    return { Url: img };
                                }) }),
                            Products: products
                        };
                    });

                    // Filter out any hotels that had all their products filtered out.
                    hotels = _.filter(hotels, function (h) {
                        return !_.isEmpty(h.Products);
                    });

                    _this5.Hotels = hotels;
                });
            } else if (this.data.SelectedDeparture && this.data.SelectedDeparture.IsAccommodations) {
                this.Hotels = [];

                // Use this in future
                // const priceGroup = this.data.Destination.PriceGroup;

                console.log('[CongressRooms] Fetching price group');

                // Get PriceGroup with SearchDepartures
                this.departureService.searchDepartures({
                    'DestCodes': [this.data.DestinationCode],
                    'Limit': 1
                }).then(function (result) {
                    var priceGroup = result.Results[0] ? result.Results[0].Pricing.Group || 'NR' : 'NR';

                    console.log('[CongressRooms] Price group:', priceGroup);

                    console.info('[CongressRooms] Fetching rooms by producers');
                    console.log('[CongressRooms] DepartureKey:', _this5.departureKey);

                    _this5.productService.getReservableProductsGroupedByProducer({
                        DestinationCode: _this5.departureKey ? _this5.departureKey.split("#")[0] : _this5.data.DestinationCode,
                        StartDate: _this5.departureKey ? _this5.departureKey.split("#")[1] : _this5.data.SelectedDeparture.DepartureDate,
                        EndDate: _this5.departureKey ? _this5.departureKey.split("#")[2] : _this5.data.SelectedDeparture.ArrivalDate2,
                        MinCapacity: 1,
                        ProductType: 'accommodation',
                        Flags: ['CheckPossiblePassengerAssignments'],
                        PriceGroup: priceGroup
                    }, _this5.localizationService.getLanguage()).then(function (hotels) {
                        _this5.state = 'ready';
                        if (hotels && hotels.length > 0) {
                            _this5.modifyHotels(hotels, overwrite, false);
                        } else {
                            console.log("[CongressRooms] No hotels received, so apparently no accommodation exists for this destination:", hotels);
                        }
                    });
                });
            } else if (this.data.SelectedDeparture && !this.data.SelectedDeparture.IsAccommodations) {
                console.log("[CongressRooms] This departure is marked to have no accommodations. Skipping the fetching of hotels and rooms.");
                this.state = 'no-accommodation';
            } else if (!this.data.SelectedDeparture) {
                this.state = 'initial';
                // console.log("[CongressRooms] No SelectedDeparture yet.");
            } else {
                this.state = 'error';
                console.error("[CongressRooms] Error!");
            }
        }
    }, {
        key: 'modifyHotels',
        value: function modifyHotels(hotels, overwrite, session) {
            var _this6 = this;

            if (overwrite == false) {
                if (!this.Hotels) {
                    this.Hotels = [];
                }
                _.each(hotels, function (h) {
                    if (!h.Producer) {
                        // No support for producerless hotels yet.
                        // I.e. image / name are needed from producer.
                        return;
                    }

                    // Merge hotels (if same producer exists, append to its
                    // products)
                    var found = false;
                    _.each(hotels, function (h2) {
                        if (h && h.Producer && h2 && h2.Producer && h.Producer.Number == h2.Producer.Number) {
                            found = true;
                            h2.Products = h2.Products.concat(h.Products);
                        }
                    });
                    if (found == false) {
                        // New producer.
                        _this6.Hotels.push(h);
                    }
                });
            } else {
                this.Hotels = hotels;
                console.log("[CongressRooms] Received hotels data:", hotels);
            }

            _.each(this.Hotels, function (hotel) {
                // Show first carousel image.
                hotel.activeImage = 0;
                hotel.displayNotes = false;

                var filteredHotelProducts = _this6.filterReservableProducts(hotel.Products);

                // If something was filtered out, report it.
                // No need to say anything otherwise.
                if (filteredHotelProducts.length < hotel.Products.length) {
                    console.log("[CongressRooms] Actually reservable, filtered hotel products:", filteredHotelProducts);
                }

                hotel.Products = filteredHotelProducts;

                _.each(hotel.Products, function (room, idx) {
                    // room.notEnoughBedsForPeople = false;
                    // if(room.DestinationInfo.Beds > this.getAccommodationPeople())
                    //     room.notEnoughBedsForPeople = true;

                    room.Gender = _this6.getMRMSGender(room);

                    // If any hotel product is cabin, all hotel products are cabins
                    if (room.DestinationInfo.ProductType === 'HY') {
                        _this6.mode = 'HY';
                    }

                    if (!session) {
                        _this6.initRoom(room);
                    }

                    _this6.$scope.$watch(function () {
                        return room.Amount;
                    }, function (num, oldNum) {
                        _this6.setRoomAmount(num, room);

                        //this.passengerAssignmentsChanged(room);
                        //this.validate();

                        // Expand the newly added room
                        if (num > oldNum) {
                            _.fill(_this6.status, false);
                            _this6.status[_this6.getRoomId(room)][oldNum] = true;
                        }
                    });
                });
            });

            // The previous filter step may have removed all the rooms in a hotel.
            // If that happened, remove the entire hotel.
            this.Hotels = _.filter(this.Hotels, function (hotel) {
                return hotel.Products.length > 0;
            });

            this.initializePassengerData();

            if (this.defaultPplToRooms == 'true') {
                this.setDefaultPplToRooms();
            }

            // Sort hotels.
            if (this.listOnly !== 'true') {
                this.sortHotels();
            }
        }

        // If the accommodation is to be shown with a message despite being blocked,
        // return the message to use.
        // If the accommodation is not blocked or not to be shown, return null.

    }, {
        key: 'getBlockerMessage',
        value: function getBlockerMessage(blockers) {
            if (_.isEmpty(blockers)) {
                // Not blocked.
                return null;
            } else if (this.showFullWithMessage && _.every(blockers, function (b) {
                return b === 'FreePlacesInsufficient';
            })) {
                // Only blocked because it's full.
                return { reason: 'full', message: this.showFullWithMessage };
            } else {
                // Blocked for some other reason. Don't show.
                // Add any new messages for other situations above this branch.
                return null;
            }
        }
    }, {
        key: 'initRoom',
        value: function initRoom(room) {
            room.DateRange = (0, _utils.formatDateRange)(room.BeginDate, room.EndDate);

            // An already-existing product line for this room, if there is one.
            var productLine = this.winresReservationContext.findProductLineByProduct(room);

            if (productLine) {
                room.Amount = productLine.Amount;
            } else {
                room.Amount = 0; // Close room by default.
            }

            // Init passenger checkboxes for each room to to empty objects
            room.PassengerCheckboxes = [];
            for (var i = 0; i < room.Amount; ++i) {
                room.PassengerCheckboxes.push({});
            }

            this.status[this.getRoomId(room)] = [];

            // User-selected rooms are open by default
            for (var _i = 0; _i < room.Amount; ++_i) {
                this.status[this.getRoomId(room)].push(true);
            }

            if (productLine && productLine.PassengerAssignments.length > 0) {
                _.each(productLine.PassengerAssignments, function (assignment) {
                    room.PassengerCheckboxes[assignment.ProductNumber - 1][assignment.PassengerNumber] = true;
                });
                this.calculateProductLinePrice(productLine);
            }
        }
    }, {
        key: 'getNotesHeight',
        value: function getNotesHeight(index) {
            return angular.element(".notes-wrapper")[index].offsetHeight;
        }
    }, {
        key: 'notesShowMore',
        value: function notesShowMore(hotel) {
            if (hotel.displayNotes == null) hotel.displayNotes = false;
            hotel.displayNotes = !hotel.displayNotes;
        }

        // Split reservable products in order groups.
        // Sort order groups contents by price.
        // Sort order groups.
        // Concat order groups in one array.

    }, {
        key: 'sortByOrderAndPrice',
        value: function sortByOrderAndPrice(reservable, hotel) {
            var groups = _.groupBy(reservable, function (group) {
                return hotel ? group.Products.length > 0 ? group.Products[0].Ordering : Number.MAX_VALUE : group.Ordering;
            });

            var priceGroups = [];
            _.each(groups, function (group) {
                priceGroups.push(_.sortBy(group, function (product) {
                    return hotel ? product.Products.length > 0 ? Number(product.Products[0].Price.replace(',', '.')) : Number.MAX_VALUE : Number(product.Price.replace(',', '.'));
                }));
            });

            var sorted = [];
            _.each(priceGroups, function (priceGroups) {
                sorted = sorted.concat(priceGroups);
            });

            return sorted;
        }

        // If number is even.
        // Used to add empty space below right side hotel card to fix odd wrapping.

    }, {
        key: 'isEven',
        value: function isEven(hotelIndex) {
            return hotelIndex - 1 & 1;
        }
    }, {
        key: 'sort',
        value: function sort(products, hotel) {
            var numPassengers = this.data.NumAdults + this.data.NumChildren;

            // Fix backend ordering.
            // _.each(this.Hotels, hotel => {
            //     _.each(hotel.Products, product => product.Ordering *= 100);
            // });

            var reservable = products;

            // Products reservabiility score
            // Bigger number = less reservable
            // Products with beds and extra beds equal to passengers are most reservable
            _.each(reservable, function (product) {
                if (hotel) {
                    var rooms = product.Products;
                    if (rooms.length > 0) {
                        var _room = rooms[0];
                        if (_room.DestinationInfo.Beds + _room.DestinationInfo.ExtraBeds > numPassengers) _room.Ordering += 100;
                        if (_room.DestinationInfo.Beds + _room.DestinationInfo.ExtraBeds < numPassengers) _room.Ordering += 1000 /*- (room.DestinationInfo.Beds + room.DestinationInfo.ExtraBeds)*/;
                        if (numPassengers === 1 && !_room.HasSinglePassengerPrice) _room.Ordering += 10000;
                    }
                } else {
                    if (product.DestinationInfo.Beds + product.DestinationInfo.ExtraBeds > numPassengers) product.Ordering += 100;
                    if (product.DestinationInfo.Beds + product.DestinationInfo.ExtraBeds < numPassengers) product.Ordering += 1000 /*- (product.DestinationInfo.Beds + product.DestinationInfo.ExtraBeds)*/;
                    if (numPassengers === 1 && !product.HasSinglePassengerPrice) product.Ordering += 10000;
                }
            });

            return this.sortByOrderAndPrice(reservable, hotel);
        }
    }, {
        key: 'sortHotels',
        value: function sortHotels() {
            var _this7 = this;

            // Sort hotel rooms.

            _.each(this.Hotels, function (hotel) {
                _.each(hotel.Products, function (product) {
                    return product.Ordering = 0;
                });
            });

            _.each(this.Hotels, function (hotel) {
                hotel.Products = _this7.sort(hotel.Products, false);
            });

            // Sort hotels by hotel first product.
            this.Hotels = this.sort(this.Hotels, true);
        }
    }, {
        key: 'setDefaultPplToRooms',
        value: function setDefaultPplToRooms() {
            var _this8 = this;

            var products = [];

            // Get bookable rooms.
            if (this.$scope.passengerAmountWithoutInfants === 1) {
                _.each(this.Hotels, function (hotel) {
                    products = products.concat(_.filter(hotel.Products, function (product) {
                        return product.HasSinglePassengerPrice;
                    }));
                });
            } else {
                _.each(this.Hotels, function (hotel) {
                    products = products.concat(_.filter(hotel.Products, function (product) {
                        return product.DestinationInfo.Beds >= _this8.$scope.passengerAmountWithoutInfants;
                    }));
                });
            }

            if (products.length === 0) return;

            // Select first room.
            var room = products[0];

            // Open single room.
            this.setRoomAmount(1, room);

            // Create checkbox array.
            if (room.PassengerCheckboxes.length === 0) {
                room.PassengerCheckboxes.push([]);
            }

            // Create checkboxes in array.
            if (room.PassengerCheckboxes[0].length === 0) {
                for (var i = 0; i < this.getAllPeople(); i++) {
                    room.PassengerCheckboxes[0].push(true);
                }
            }

            // Set checkboxes on.
            for (var i = 0; i < this.getAllPeople(); i++) {
                room.PassengerCheckboxes[0][i] = true;
            }
        }

        // Finds a product (room) from displayed rooms by productLine

    }, {
        key: 'findProduct',
        value: function findProduct(productLine) {
            var result = null;
            _.each(this.Hotels, function (hotel) {
                _.each(hotel.Products, function (product) {
                    if (product.StartDate == productLine.Product.StartDate && product.EndDate == productLine.Product.EndDate && product.DestinationInfo.ProductCode == productLine.Product.DestinationInfo.ProductCode && product.DestinationInfo.DestinationCode == productLine.Product.DestinationInfo.DestinationCode) {
                        result = product;
                    }
                });
            });
            return result;
        }
    }, {
        key: 'removePassengerAssignments',
        value: function removePassengerAssignments(room) {
            var _this9 = this;

            _.each(room.PassengerCheckboxes, function (checkboxes) {
                for (var i = 0; i < _this9.getAllPeople(); i++) {
                    if (checkboxes[i]) {
                        checkboxes[i] = false;
                    }
                }
            });
        }
    }, {
        key: 'uncheckDisabledCheckboxes',
        value: function uncheckDisabledCheckboxes(room, amount) {
            var passengerCount = this.passengers.length;

            for (var i = 0; i < passengerCount; i++) {
                for (var j = 0; j < amount; j++) {
                    if (this.isCheckboxDisabled(room, i, j)) {
                        if (room.PassengerCheckboxes[i] && room.PassengerCheckboxes[i][j]) room.PassengerCheckboxes[i][j] = false;
                    }
                }
            }

            // Clear hidden checkboxes on select less rooms
            for (var i = 0; i < room.PassengerCheckboxes.length; i++) {
                if (i > amount - 1) {
                    room.PassengerCheckboxes[i] = {};
                }
            }
        }

        // room: product, not productLine

    }, {
        key: 'setRoomAmount',
        value: function setRoomAmount(amount, room) {
            // log('Setting room amount to', amount, 'for:', _.cloneDeep(room));

            // Uncheck disabled checkboxes
            this.uncheckDisabledCheckboxes(room, amount);

            room.Amount = amount;
            var line = this.winresReservationContext.findProductLineByProduct(room);

            if (amount > 0) {
                // Check if room has adult
                this.checkRoomAdult(room);
            }

            if (line) {
                line.Amount = amount;
                if (!amount) {
                    // log('Removing product line:', _.cloneDeep(line));

                    // Remove all passenger assignments from room
                    this.removePassengerAssignments(room);

                    _.pull(this.data.Products, line);
                }
            } else if (amount > 0) {
                line = {
                    Product: room,
                    Amount: amount,
                    PassengerAssignments: []
                };

                // log('Adding product line:', line);
                this.data.Products.push(line);

                // this.updateAssignments(room);

                // this.$scope.$watch(() => selected.PassengerAssignments,
                //                    () => this.passengerAssignmentsChanged(room) );
            }

            if (amount > 0) {
                // Watch room type for changes if not already watching.
                if (!room.checkboxWatch) {
                    this.watchRoomCheckboxes(room);
                }
            } else {
                // Stop watching room type since there are no more members of it
                if (room.checkboxWatch) {
                    room.checkboxWatch();
                    room.checkboxWatch = null;
                }
            }

            return line;
        }
    }, {
        key: 'watchRoomCheckboxes',
        value: function watchRoomCheckboxes(room) {
            var _this10 = this;

            room.checkboxWatch = this.$scope.$watch(function () {
                return room.PassengerCheckboxes;
            }, function () {
                var passengerCheckboxes = getRoomTypeCheckboxes(room);

                var checkboxCount = 0;
                _.each(passengerCheckboxes, function (roomCheckboxes) {
                    _.each(roomCheckboxes, function (checkbox) {
                        if (checkbox) checkboxCount++;
                    });
                });

                _this10.updateAssignments(room);

                // No checkboxes. Remove room product.
                if (checkboxCount === 0) {
                    var productLine = _this10.winresReservationContext.findProductLineByProduct(room);
                    if (productLine) {
                        _.pull(_this10.data.Products, productLine);
                    }
                } else {
                    // Add room product.
                    _this10.setRoomAmount(room.Amount, room);
                    _this10.passengerAssignmentsChanged(room);
                }

                if (room.Gender) {
                    // Get all possible selected MRMS passenger assignments
                    var checkboxes = _this10.getMRMSCheckboxes();

                    // Remove passenger info gender lock and reset gender
                    _this10.clearPassengersGenderLock();

                    if (checkboxes.length > 0) {
                        _this10.updateMRMSRooms(checkboxes);
                    }
                }

                _this10.checkRoomAdult(room);

                _this10.validate();
            }, true);
        }
    }, {
        key: 'checkRoomAdult',
        value: function checkRoomAdult(room) {
            var _this11 = this;

            room.HasAdult = {};
            for (var i = 0; i < room.Amount; i++) {
                room.HasAdult[i] = { value: false,
                    checkboxes: {},
                    checkboxgenders: {} };

                for (var j = 0; j < this.data.Passengers.length; j++) {
                    room.HasAdult[i].checkboxes[j] = false;
                    room.HasAdult[i].checkboxgenders[j] = this.data.Passengers[j].IsAdult || this.data.Passengers[j].IsCustomer ? 'adult' : 'child';
                }
            }

            _.each(room.PassengerCheckboxes, function (checkboxes, roomIdx) {
                _.each(checkboxes, function (checkbox, idx) {
                    if (checkbox == true) {
                        if (room.HasAdult[roomIdx]) {
                            if (_this11.data.Passengers[idx].IsAdult || _this11.data.Passengers[idx].IsCustomer) {
                                room.HasAdult[roomIdx].value = true;
                            }
                            room.HasAdult[roomIdx].checkboxes = checkboxes;
                        }
                    }
                });
            });

            // Deselect all child and infant checkboxes if no adults in room
            for (var roomIdx in room.HasAdult) {
                if (room.HasAdult[roomIdx] && room.HasAdult[roomIdx].value == false) {
                    for (var idx in room.HasAdult[roomIdx].checkboxes) {
                        if (room.HasAdult[roomIdx].checkboxgenders[idx] == 'child') room.HasAdult[roomIdx].checkboxes[idx] = false;
                    }
                }
            }
        }
    }, {
        key: 'clearPassengersGenderLock',
        value: function clearPassengersGenderLock() {
            _.each(this.passengers, function (passenger) {
                if (passenger.lockGender) {
                    var gender = null;

                    if (passenger.IsChild) gender = 'CH';else if (passenger.IsInfant) gender = 'IN';

                    passenger.Gender = gender;
                    passenger.lockGender = null;
                }
            });
        }
    }, {
        key: 'updateMRMSRooms',
        value: function updateMRMSRooms(checkboxes) {
            var _this12 = this;

            _.each(checkboxes, function (checkbox) {
                var passenger = _this12.passengers[checkbox.idx];
                var gender = checkbox.gender;

                var childGender = _this12.getChildGender(gender, passenger.Gender);
                if (childGender.startsWith('CH') || childGender.startsWith('IN')) {
                    gender = childGender;
                }

                passenger.Gender = gender;
                passenger.lockGender = gender;
            });
        }
    }, {
        key: 'getMRMSGender',
        value: function getMRMSGender(room) {
            return room.DestinationInfo.ProductCode.split('/')[1];
        }
    }, {
        key: 'getMRMSCheckboxes',
        value: function getMRMSCheckboxes() {
            var checkboxes = [];

            _.each(this.Hotels, function (hotel) {
                _.each(hotel.Products, function (room) {
                    if (room.Gender) {
                        _.each(room.PassengerCheckboxes, function (chks) {
                            _.each(chks, function (checkbox, idx) {
                                if (checkbox == true) {
                                    if (!_.find(checkboxes, function (chk) {
                                        return chk.idx == idx;
                                    })) checkboxes.push({
                                        idx: idx,
                                        gender: room.Gender,
                                        value: checkbox
                                    });
                                }
                            });
                        });
                    }
                });
            });

            return checkboxes;
        }
    }, {
        key: 'getChildGender',
        value: function getChildGender(roomGender, passengerGender) {
            if (!passengerGender) return roomGender;
            if (passengerGender.startsWith('CH')) {
                if (roomGender == 'MR') roomGender = 'CH/M';else if (roomGender == 'MS') roomGender = 'CH/F';
            } else if (passengerGender.startsWith('IN')) {
                roomGender = 'IN';
            }
            return roomGender;
        }
    }, {
        key: 'addRoom',
        value: function addRoom(amount, room) {
            var _this13 = this;

            var selected = this.winresReservationContext.findProductLineByProduct(room);

            if (selected) {
                selected.Amount = amount;
                if (!amount) {
                    _.pull(this.data.Products, selected);
                }
            } else {
                var productLine = {
                    Product: room,
                    Amount: amount,
                    PassengerAssignments: []
                };
                this.data.Products.push(productLine);

                this.$scope.$watch(function () {
                    return productLine.PassengerAssignments;
                }, function () {
                    return _this13.passengerAssignmentsChanged(room);
                });
            }
        }
    }, {
        key: 'calculateProductLinePrice',
        value: function calculateProductLinePrice(productLine) {
            // If there's already an existing request for this line, cancel it.
            if (productLine.X_PricePending) {
                // console.log('[CongressRooms] Canceling previous pending request for product line:', productLine);
                this.cancelService.cancel(productLine.X_PricePending);
                delete productLine['X_PricePending'];
            }

            // Passenger info changed CalculateProductLinePrices request 2.
            var request = this.reservationService.calculateProductLinePrice(this.data, productLine, this.localizationService.getLanguage());

            // Keep track of the currently pending request.
            // This field will be deleted once the request completes or fails.
            productLine.X_PricePending = request;

            // Also store it for actual use by the new <load> component.
            // The difference compared to the above is that this reference
            // is not deleted when the request completes.
            productLine.X_Price = request;

            // With the new <load> component in place, the below lines are probably
            // only needed to show the correct price in the shopping cart.
            // Previously, they were also used by this component (congress-rooms).

            request.then(function (pricingResult) {
                delete productLine['X_PricePending'];

                // console.log("[CongressRooms] got productline pricingResult: ",pricingResult);
                if (pricingResult) {
                    productLine.UnitPrice = pricingResult.UnitPrice;
                    productLine.TotalPrice = pricingResult.Price;
                    productLine.SingleSupplement = pricingResult.SingleSupplement;
                } else {
                    if (pricingResult === undefined) {
                        // It was canceled or not performed due to validity check in service.
                        // No need to log it.
                    } else {
                        // Something else went wrong.
                        console.warn('[CongressRooms] Failed to calculate product line price.');

                        productLine.UnitPrice = undefined;
                        productLine.TotalPrice = undefined;
                        productLine.SingleSupplement = undefined;
                    }
                }
            }, function (error) {
                delete productLine['X_PricePending'];

                // Re-throw error, we're just here to mark the request as no longer pending.
                throw error;
            });
        }
    }, {
        key: 'removeRoom',
        value: function removeRoom(room) {
            var selected = this.winresReservationContext.findProductLineByProduct(room);
            if (selected.Amount <= 1) {
                _.pull(this.data.Products, selected);
            } else {
                selected.Amount -= 1;
                this.passengerAssignmentsChanged(selected);
                this.updateAssignments(selected);
            }
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _this14 = this;

            var errors = [];
            var errorType = this.mode === 'HY' ? '_cabin' : '_room';

            if (!this.data) {
                // console.log('[WinresReservationCongressRooms] No data available, skipping validation.');
            } else if (!this.data.SelectedDeparture) {
                // console.log('[WinresReservationCongressRooms] No selected departure, skipping validation.');
            } else if (!this.data.SelectedDeparture.IsAccommodations) {
                console.log('[WinresReservationCongressRooms] Departure has no accommodation, skipping validation.');
            } else {
                if (this.requireAllAccommodated == 'true' || this.requireAllOrNoneAccommodated == 'true') {
                    if (!this.hasEnoughAccommodations()) {
                        if (!(this.requireAllOrNoneAccommodated == 'true' && !this.hasAnyAccommodations())) {
                            errors.push('reservation_accommodation.error_too_few' + errorType);
                        }
                    }
                }

                if (this.disallowExtraOccupancy == 'true' && this.hasMoreAccommodationsThanNeeded()) {
                    errors.push('reservation_accommodation.error_too_many' + errorType);
                }

                var numPassengers = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;

                // Check that all passengers are assigned to cabins. Alternatively,
                // check that all or none are accommodated. This use case exists for K&K
                if (this.requireAllAccommodated == 'true' || this.requireAllOrNoneAccommodated == 'true') {
                    var passengerErrors = [];
                    for (var i = 0; i < numPassengers; ++i) {
                        if (!this.isPassengerAccommodated(i)) {
                            passengerErrors.push({
                                Message: 'reservation_accommodation.error_passenger' + errorType,
                                Params: {
                                    passenger: this.PassengerNames[i]
                                }
                            });
                        }
                    }
                    if (passengerErrors.length != numPassengers || this.requireAllOrNoneAccommodated != 'true') {
                        errors = errors.concat(passengerErrors);
                    }
                }

                if (this.showSinglePassengerError) {
                    errors.push('reservation_accommodation.singlePersonAccommondationNotPossible');
                }

                if (numPassengers > 0 && this.passengers && _.every(this.passengers, function (p) {
                    return p != null;
                })) {
                    var hotels = this.data && this.Hotels || [];

                    _.forEach(hotels, function (hotel) {
                        var roomTypes = hotel.Products;
                        _.forEach(roomTypes, function (roomType) {
                            _.forEach(_.range(0, roomType.Amount), function (roomNumber) {
                                var state = _this14.getRoomState(roomType, roomNumber);
                                if (state.startsWith('invalid')) {
                                    errors.push({
                                        Message: 'reservation_accommodation.error_room_state.' + state,
                                        Params: {
                                            name: roomType.Producer ? roomType.Producer.Company + ' / ' + roomType.DestinationInfo.ProductName : roomType.DestinationInfo.ProductName,
                                            number: roomNumber + 1
                                        }
                                    });
                                }
                            });
                        });
                    });
                }

                // _.each(this.data.Products, productLine => {
                //     let params = {
                //         name: productLine.Product.DestinationInfo.ProductName,
                //         num: productLine.Product.DestinationInfo.Beds
                //     }

                //     if(productLine.Product.notEnoughBedsError || productLine.Product.notEnoughBedsForPeople) {
                //         errors.push({
                //             Message: 'reservation_accommodation.notEnoughBedsForPeople',
                //             Params: params
                //         });
                //     }
                // });
            }

            this.winresReservationContext.setReservationComponentErrors('accommodation', 'accommodation', errors);
        }
    }, {
        key: 'hasMoreAccommodationsThanNeeded',
        value: function hasMoreAccommodationsThanNeeded() {
            var numPassengers = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
            // TODO Handle extra beds (need info on whether room can be booked for
            // adults / children in extra beds)

            // possibly(hopefully) done, this does not need the info on can it be booked since user
            // can't select passengers to extra beds if it is not allowed.
            if (this.everyoneCanHaveOwnRoom) {
                return this.getNumRoomsSelected() > numPassengers;
            }
            return this.getNumBedsSelected() + this.getNumExtraBedsSelected() > numPassengers;
        }
    }, {
        key: 'hasEnoughAccommodations',
        value: function hasEnoughAccommodations() {
            var numPassengers = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
            // TODO Handle extra beds (need info on whether room can be booked for
            // adults / children in extra beds)

            // possibly(hopefully) done, this does not need the info on can it be booked since user
            // can't select passengers to extra beds if it is not allowed.

            return this.getNumBedsSelected() + this.getNumExtraBedsSelected() + this.data.NumInfants >= numPassengers;
        }
    }, {
        key: 'getNumBedsSelected',
        value: function getNumBedsSelected() {
            var products = this.getSelectedAccommodationProducts();
            var result = 0;
            _.each(products, function (product) {
                result += product.Amount * product.Product.DestinationInfo.Beds;
            });
            return result;
        }
    }, {
        key: 'getNumRoomsSelected',
        value: function getNumRoomsSelected() {
            var products = this.getSelectedAccommodationProducts();
            var result = 0;
            _.each(products, function (product) {
                result += product.Amount;
            });
            return result;
        }
    }, {
        key: 'getHowManyPeople',
        value: function getHowManyPeople() {
            return this.data.NumAdults;
        }
    }, {
        key: 'getAccommodationPeople',
        value: function getAccommodationPeople() {
            return this.data.NumAdults + this.data.NumChildren;
        }
    }, {
        key: 'getAllPeople',
        value: function getAllPeople() {
            return this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
        }
    }, {
        key: 'getNumExtraBedsSelected',
        value: function getNumExtraBedsSelected() {
            var products = this.getSelectedAccommodationProducts();
            var result = 0;
            _.each(products, function (product) {
                result += product.Product.DestinationInfo.ExtraBeds;
            });
            return result;
        }
    }, {
        key: 'hasAnyAccommodations',
        value: function hasAnyAccommodations() {
            return this.getSelectedAccommodationProducts().length > 0;
        }
    }, {
        key: 'getSelectedAccommodationProducts',
        value: function getSelectedAccommodationProducts() {
            //'HUHY'.indexOf(p.Product.DestinationInfo.ProductType>-1)
            return _.filter(this.data.Products, function (p) {
                return (p.Product.DestinationInfo.ProductType == 'HY' || p.Product.DestinationInfo.ProductType == 'HU') && p.Amount > 0;
            });
        }
    }, {
        key: 'initializePassengerData',
        value: function initializePassengerData() {
            var _this15 = this;

            this.PassengerNames = this.winresReservationContext.getPassengerDisplayNames();

            this.$scope.passengerAmountWithoutInfants = this.data.NumAdults + this.data.NumChildren;

            //this.NoRoomsAvailableForSinglePerson = this.PassengerNames.length==1 && _.every(this.data.Products, p=>p.Product.HasSinglePassengerPrice==false);
            //this.data.Products[0].HasSinglePassengerPrice = true;

            // Initialize cabin assignments
            _.each(this.Hotels, function (hotel) {
                _.each(hotel.Products, function (product) {
                    _this15.passengerAssignmentsChanged(product);
                });
            });
        }

        // Assignments -> checkbox model. Called in $watches.
        // (this triggers e.g. when a passenger is removed and thus passengers are
        //  re-numbered)

    }, {
        key: 'passengerAssignmentsChanged',
        value: function passengerAssignmentsChanged(product) {
            var passengerCheckboxes = getRoomTypeCheckboxes(product);
            if (!hasCheckboxes(passengerCheckboxes)) {
                product.PassengerCheckboxes = [];
                for (var i = 0; i < product.Amount; ++i) {
                    product.PassengerCheckboxes.push({});
                }
            }

            var productLine = this.winresReservationContext.findProductLineByProduct(product);

            if (productLine && productLine.PassengerAssignments.length > 0) {
                _.each(productLine.PassengerAssignments, function (assignment) {
                    product.PassengerCheckboxes[assignment.ProductNumber - 1][assignment.PassengerNumber] = true;
                });
                this.calculateProductLinePrice(productLine);
            }
        }

        // , model -> assignments. Called in onchange in template.

    }, {
        key: 'updateAssignments',
        value: function updateAssignments(product) {
            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);

            productLine.PassengerAssignments = [];
            _.each(product.PassengerCheckboxes, function (checkboxes, roomIndex) {
                _.each(checkboxes, function (value, passengerNumber) {
                    if (value) {
                        productLine.PassengerAssignments.push({
                            PassengerNumber: parseInt(passengerNumber),
                            ProductNumber: parseInt(roomIndex) + 1
                        });
                    }
                });
            });

            // Get passenger assignment errors. Single passenger. Not enough beds.
            this.getPassengerAssignmentErrors();

            this.validate();
        }
    }, {
        key: 'getCheckboxArray',
        value: function getCheckboxArray(product) {
            var checkboxArray = [];
            _.each(product.PassengerCheckboxes, function (checkboxes, idx) {
                var checkboxCount = 0;
                _.each(checkboxes, function (value) {
                    if (value) checkboxCount++;
                });
                checkboxArray.push({ idx: idx, count: checkboxCount });
            });
            return checkboxArray;
        }
    }, {
        key: 'getPassengerAssignmentErrors',
        value: function getPassengerAssignmentErrors() {
            var _this16 = this;

            this.showSinglePassengerError = false;
            _.each(this.data.Products, function (productLine) {
                var product = productLine.Product;

                // Product rooms.
                var checkboxArray = _this16.getCheckboxArray(product);

                product.showSinglePassengerError = false;

                if (_.some(checkboxArray, function (checkbox) {
                    return checkbox.count == 1 && product.HasSinglePassengerPrice === false && product.DestinationInfo.Accommodation === true;
                })) {
                    _this16.showSinglePassengerError = true;
                    product.showSinglePassengerError = true;
                }

                // product.notEnoughBedsError = false;
                // if (_.some(checkboxArray, checkbox => checkbox.count > 0
                //     && checkbox.count < product.DestinationInfo.Beds
                //     && product.DestinationInfo.Accommodation === true)) {
                //     product.notEnoughBedsError = true;
                // }
            });
        }

        /*hasCheckboxes(idx, checkboxArray){
            for(var key in checkboxArray){
                return checkboxArray[key].idx == idx && checkboxArray[key].count == 0;
            }
            return false;
        }*/

    }, {
        key: 'initializeWatches',
        value: function initializeWatches() {
            var _this17 = this;

            _.each(this.Hotels, function (hotel) {
                _.each(hotel.Products, function (room) {
                    var productLine = _this17.winresReservationContext.findOrCreateProductLineByProduct(room);
                    if (productLine) {
                        // TODO Watches are leaked here.
                        productLine.Product = room;
                        productLine.Amount = room.Amount;
                        productLine.PassengerAssignments = [];

                        // Watch checkboxes.
                        _this17.$scope.$watch(function () {
                            return productLine.PassengerAssignments;
                        }, function () {
                            return _this17.passengerAssignmentsChanged(room);
                        });

                        // Watch rooms amount dropdown.
                        _this17.$scope.$watch(function () {
                            return room.Amount;
                        }, function (num) {
                            return _this17.setRoomAmount(num, room);
                        });

                        // Update checkboxes.
                        _this17.updateAssignments(room);
                    }
                });
            });
        }
    }, {
        key: 'isPassengerAccommodated',
        value: function isPassengerAccommodated(passengerIndex) {
            var _this18 = this;

            var isAccommodated = false;
            _.each(this.Hotels, function (hotel) {
                _.each(hotel.Products, function (r) {
                    var productLine2 = _this18.winresReservationContext.findProductLineByProduct(r);
                    if (!productLine2 || !productLine2.PassengerAssignments) {
                        return;
                    }
                    isAccommodated |= _.some(productLine2.PassengerAssignments, function (a) {
                        return a.PassengerNumber == passengerIndex;
                    });
                });
            });
            return isAccommodated;
        }
    }, {
        key: 'getRoomPassengerAssignments',
        value: function getRoomPassengerAssignments(room, roomNumber) {
            var productLine = this.winresReservationContext.findProductLineByProduct(room);
            if (!productLine || !productLine.PassengerAssignments) {
                return [];
            }
            return _.filter(productLine.PassengerAssignments, function (a) {
                return a.ProductNumber == roomNumber + 1;
            });
        }
    }, {
        key: 'totalRoomNonInfants',
        value: function totalRoomNonInfants(room, roomNumber) {
            var count = this.countRoomPassengers(room, roomNumber);
            return count.adults + count.children;
        }
    }, {
        key: 'countRoomPassengers',
        value: function countRoomPassengers(room, roomNumber) {
            var checkboxes = getRoomCheckboxes(room, roomNumber);
            var count = countAssignedPassengersByType(checkboxes, this.passengers);
            return count;
        }
    }, {
        key: 'getRoomState',
        value: function getRoomState(room, roomNumber) {
            // List of this room's checkboxes as booleans. True if checked.
            var checkboxes = getRoomCheckboxes(room, roomNumber);

            // Is the room empty?
            if (!_.some(checkboxes)) {
                return 'empty';
            }

            // Count of passengers assigned to this particular room at the moment.
            // Example: { adults: 2, children: 1, infants: 0 }.
            var count = countAssignedPassengersByType(checkboxes, this.passengers);

            // The above in a readable string form (e.g. "A2C1I0")
            var assignment = countToString(count);

            // Is the room bookable for the given occupants?
            var valid = assignmentIsPossible(assignment, room);

            if (!valid) {
                // Can we reach a valid state by removing occupants?
                var tooMany = findReachablePossibleDifferentCount(count, room, true);

                // Can we reach a valid state by adding occupants?
                var tooFew = findReachablePossibleDifferentCount(count, room, false);

                if (tooMany && tooFew) {
                    // Example: 4 beds, can be booked for 2 or 4, but we have 3 occupants.
                    return 'invalid';
                } else if (tooMany) {
                    // Example: 1 bed, but we have 2 occupants.
                    return 'invalid-toomany';
                } else if (tooFew) {
                    // Example: 6 beds, but we have 2 occupants.
                    return 'invalid-toofew';
                } else {
                    // It seems there is no valid configuration at all.
                    return 'invalid';
                }
            }

            // Is the room full?

            // NOTE: Since infants can pretty much always be added to a room, we must ignore
            // infants here. This, the room is considered full if no non-infant passengers
            // can be added. This is calculated by pretending that there are no more infants
            // in the total passenger list than have been already added to this room.

            // Count all passengers.
            var maxCount = countPassengersByType(this.passengers);

            // Pretend the infants already assigned to this room are the only ones that exist.
            maxCount.infants = count.infants;

            var canAdd = findReachablePossibleDifferentCount(count, room, false, maxCount);
            if (!canAdd) {
                return 'valid-full';
            }

            // The room is bookable for the given occupants, but not full.
            return 'valid';
        }

        // Old function, retained in case some other template still uses it

    }, {
        key: 'isRoomEmpty',
        value: function isRoomEmpty(room, roomNumber) {
            return this.getRoomState(room, roomNumber) === 'empty';
        }

        // Old function, retained in case some other template still uses it

    }, {
        key: 'isRoomFull',
        value: function isRoomFull(room, roomNumber) {
            return this.getRoomState(room, roomNumber) === 'valid-full';
        }

        /*isNoRoomForSinglePerson(room){
            return (this.PassengerNames.length==1 && room.HasSinglePassengerPrice == false);
        }*/

    }, {
        key: 'getRoomId',
        value: function getRoomId(room) {
            return [room.DestinationInfo.DestinationCode, room.DestinationInfo.ProductCode, room.BeginDate, room.EndDate].join('-');
        }
    }, {
        key: 'isDisabledByGender',
        value: function isDisabledByGender(roomGender, passengerGender) {
            return roomGender && passengerGender && passengerGender != roomGender;
        }
    }, {
        key: 'isCheckboxDisabled',
        value: function isCheckboxDisabled(room, passengerIndex, roomNumber) {
            var roomDesc = getRoomDesc(room);

            var passenger = this.passengers[passengerIndex];
            if (!passenger) {
                console.warn('[WRCR isCheckboxDisabled]', roomDesc, 'No passenger with index:', passengerIndex);
                return true;
            }

            if (this.isDisabledByGender(room.Gender, passenger.Gender)) {
                // log('Room disabled by gender:', _.cloneDeep(room));
                return true;
            }

            // List of this room's checkboxes as booleans. True if checked.
            var checkboxes = getRoomCheckboxes(room, roomNumber);

            // Always allow to deselect a passenger.
            var checked = checkboxes[passengerIndex];
            if (checked) {
                // log('Box is already checked:', passengerIndex, checkboxes);
                return false;
            }

            // Disallow when passenger is already selected.
            // Note that we have to check every room, not just this one.
            if (this.isPassengerAccommodated(passengerIndex)) {
                // log('Passenger is already accommodated:', passengerIndex);
                return true;
            }

            // Count of passengers assigned to this particular room at the moment.
            // Example: { adults: 2, children: 1, infants: 0 }.
            var count = countAssignedPassengersByType(checkboxes, this.passengers);

            // This passenger's category: 'adults', 'children' or 'infants'.
            var category = getPassengerCategory(passenger);

            // Disallow adding children or infants to a room with no adults.
            // NOTE: This could be allowed, since we could still check that the adult gets
            // added later. However, there is other logic elsewhere in this function
            // that will uncheck the box immediately even if we allow it here. That means
            // the box is practically disabled anyway, even though it doesn't look like it.
            // That will confuse the user, so it's better to mark the box as disabled here.
            if (category != 'adults' && count.adults === 0) {
                return true;
            }

            // The above in a readable string form (e.g. "A2C1I0")
            var assignment = countToString(count);

            if (!findReachablePossibleCount(count, room)) {
                console.warn('[WRCR isCheckboxDisabled]', roomDesc, '- Sanity check failed: current passenger assignment', assignment, 'is not possible and does not lead to any possible assignments.');
                return false;
            }

            // Like count above, but after checking this box.
            var newCount = getCountWithAddedPassenger(count, passenger);

            // Find a possible count for the room type that can be reached from
            // the current count by checking this box and possibly adding more
            // passengers after that.
            // If there is no way to make the new count valid by adding more people
            // (for example, if the new count is 3 adults in a two-person room),
            // this will be null.
            var possibleTargetCount = findReachablePossibleCount(newCount, room);

            if (possibleTargetCount) {
                // console.log('[WRCR isCheckboxDisabled]', roomDesc, '- Assignment', countToString(newCount), 'leads to', countToString(possibleTargetCount));
            } else {
                // No valid count can be reached after checking this box.
                // The box should be disabled.
                // console.log('[WRCR isCheckboxDisabled]', roomDesc, '- Assignment', countToString(newCount), 'leads to no possible count.');
                return true;
            }

            // Disable remaining checkboxes to force passengers in all rooms
            // This check is activated only for multi room assignments
            if (this.requirePassengersInAllRooms(room, checkboxes)) {
                return true;
            }

            // Allow by default
            return false;
        }
    }, {
        key: 'requirePassengersInAllRooms',
        value: function requirePassengersInAllRooms(room, checkboxes) {
            var checkboxCount = +_.sum(checkboxes, function (checkbox) {
                return checkbox === true;
            });
            var passengerCount = this.passengers.length;

            // Invalid
            if (room.Amount > 1 && checkboxCount + room.Amount >= passengerCount + 1) {
                return true;
            }

            return false;
        }

        // THIS FUNCTION IS NOT CURRENTLY USED, BUT IT CAN BE USED TO CHECK IF THE CURRENT
        // CHECKBOX STATE IS VALID.
        // A NOTIFICATION FOR THIS NEEDS TO BE ADDED TO THE TEMPLATE IN THAT CASE.

    }, {
        key: 'validateRoomCheckboxes',
        value: function validateRoomCheckboxes(roomForm, roomType, roomNumber) {
            // List of this room's checkboxes as booleans. True if checked.
            var checkboxes = getRoomCheckboxes(roomType, roomNumber);

            // Count of passengers assigned to this particular room at the moment.
            // Example: { adults: 2, children: 1, infants: 0 }.
            var count = countAssignedPassengersByType(checkboxes, this.passengers);

            var assignment = countToString(count);

            var valid = assignmentIsPossible(assignment, roomType);
            console.log('[WRCR validateRoomCheckboxes]', getRoomDesc(roomType), '- Current assignment', assignment, 'is', valid ? 'valid' : 'invalid');

            roomForm.$setValidity('passengerAssignment', valid, roomForm);
        }

        // returns true if there are children in normal beds

    }, {
        key: 'childrenInBeds',
        value: function childrenInBeds(room, assignments) {
            return this.getAmountOfAssignedAdults(assignments) < room.DestinationInfo.Beds;
        }
    }, {
        key: 'getAmountOfAssignedAdults',
        value: function getAmountOfAssignedAdults(assignments) {
            var amount = 0;
            for (var i = 0; i < assignments.length; i++) {
                var passenger = this.data.Passengers[assignments[i].PassengerNumber];
                if (passenger && passenger.Gender && !passenger.Gender.includes('CH') && !passenger.Gender.includes('IN')) {
                    amount++;
                }
            }
            return amount;
        }
    }, {
        key: 'howManyIsNotAccommodated',
        value: function howManyIsNotAccommodated() {
            this.pplAccomodated = 0;
            if (this.data.Products.length > 0) {
                for (var i = 0; i < this.data.Products.length; i++) {
                    if (this.data.Products[i].Product.DestinationInfo.Accommodation == true) {
                        this.pplAccomodated = this.pplAccomodated + this.data.Products[i].PassengerAssignments.length;
                    }
                }
            }
            return this.data.NumAdults + this.data.NumChildren + this.data.NumInfants - this.pplAccomodated;
        }

        // FIXME

    }, {
        key: 'scrollToTabs',
        value: function scrollToTabs() {
            if (this.scrollOnce) return;
            if (!this.scrollOnce) this.scrollOnce = true;
            this.$timeout(function () {
                var tabScroll = function tabScroll() {
                    var tab = document.getElementsByTagName("winres-reservation-shopping-tabs")[0];
                    if (tab) {
                        var oldPadding = tab.style.padding;
                        tab.style.padding = window.innerHeight / 4 + "px"; // add scroll height. -640
                        tab.scrollIntoView();
                        tab.style.padding = oldPadding;
                    }
                    //window.location.hash = window.location.hash.replace("/:tab", ""); // Remove /:tab from url.
                };

                tabScroll();

                var getTabByText = function getTabByText(text) {
                    var select = jQuery("a").filter(function () {
                        return this.text.toUpperCase() == text.toUpperCase();
                    });
                    return select[0];
                };

                var tabCheckTimes = 0;
                var tabCheck = setInterval(function () {
                    //var defaultTab = document.querySelector("a[href='#tab-3168cfcb-8f24-1']"); // Kohteen kuvaus
                    // tabCheckTimes++;
                    // if(tabCheckTimes>16){
                    //     clearInterval(tabCheck);
                    //     //tabScroll();
                    //     return;
                    // }

                    var defaultTab = getTabByText("kohteen kuvaus");
                    if (defaultTab) {
                        var classList = defaultTab.parentNode.classList;
                        if (classList.value == "active") {
                            getTabByText("varaa matka").click();
                            clearInterval(tabCheck);
                            tabScroll();
                        };
                    }
                }, 50);
            }, 100);

            // Clear tab=1 cookie.
            _.each(document.cookie.split(';'), function (c) {
                var n = c.trim().split('=')[0];
                if (n.indexOf("tab") > -1) {
                    document.cookie = n + '=;' + 'expires=Thu, 01 Jan 1970 00:00:00 UTC;';
                }
            });
        }
    }, {
        key: 'filterReservableProducts',
        value: function filterReservableProducts(products) {
            var _this19 = this;

            return _.filter(products, function (product) {
                if (!product.ReservabilityCheckResults.CapacityAvailable) {
                    log('Filtered out', getRoomDesc(product), 'because it has no available capacity. Product:', product);
                    return false;
                } else if (!product.ReservabilityCheckResults.Price) {
                    log('Filtered out', getRoomDesc(product), 'because it has no price. Product:', product);
                    return false;
                }

                if (_this19.settings.HideLargerRooms) {
                    var count = countPassengersByType(_this19.passengers);
                    if (roomIsTooLarge(count, product)) {
                        log('Filtered out', getRoomDesc(product), 'because it is too large for the amount of passengers. Product:', product);
                        return false;
                    }
                }

                // Passing the check is normal and expected, so no need to report it.
                // Just report if it fails.
                // console.log("[CongressRooms] Filtering reservable products... Product '" + product.DestinationInfo.ProductName + "', passes the check");
                return true;
            });
        }
    }, {
        key: 'getRoomClass',
        value: function getRoomClass(room) {
            var kind = this.getRoomKind(room);
            if (kind === 'mr_place') {
                return 'room-mr';
            } else if (kind === 'ms_place') {
                return 'room-ms';
            } else {
                return 'room-normal';
            }
        }
    }, {
        key: 'getRoomKind',
        value: function getRoomKind(room) {
            var prod = room && room.DestinationInfo && room.DestinationInfo.ProductCode || '';
            if (prod.endsWith('/MR')) {
                return 'mr_place';
            } else if (prod.endsWith('/MS')) {
                return 'ms_place';
            } else if (this.mode === 'HY') {
                return 'cabin';
            } else {
                return 'room';
            }
        }

        // Check if producer has any visible info.

    }, {
        key: 'producerHasInfo',
        value: function producerHasInfo(producer) {
            return producer && (producer.Company && this.hideName !== 'true' || producer.StreetAddress || producer.PostalAddress || producer.Note1 || producer.Note2 || producer.Note3 || producer.Note4);
        }
    }]);

    return WinresReservationCongressRoomsController;
}();

// Take the list of all passengers.
// Return a count of passengers by category,
// e.g. { adults: 2, children: 1, infants : 0}


function countPassengersByType(passengers) {
    var count = { adults: 0, children: 0, infants: 0 };
    _.forEach(passengers, function (passenger) {
        var category = getPassengerCategory(passenger);
        ++count[category];
    });
    return count;
}

// Take list of checkboxes and the list of all passengers.
// Return a count of passengers assigned to the room by category,
// e.g. { adults: 2, children: 1, infants : 0}
function countAssignedPassengersByType(checkboxes, passengers) {
    var count = { adults: 0, children: 0, infants: 0 };
    for (var i = 0; i < checkboxes.length; ++i) {
        if (checkboxes[i]) {
            var passenger = passengers[i];
            if (passenger) {
                var category = getPassengerCategory(passenger);
                ++count[category];
            }
        }
    }
    return count;
}

function getCountWithAddedPassenger(count, passenger) {
    var copy = _.clone(count);
    var category = getPassengerCategory(passenger);
    ++copy[category];
    return copy;
}

// Return 'adults', 'children' or 'infants'.
function getPassengerCategory(passenger) {
    if (passenger.IsChild) {
        return 'children';
    } else if (passenger.IsInfant) {
        return 'infants';
    } else {
        return 'adults';
    }
}

// Find a passenger category count that is possible for the room type
// and can be reached from the given count by adding more occupants
// (when byRemoving == false) or removing existing occupants (when
// byRemoving == true).
//
// If the maximum count (maxCount) is provided, also check that the
// found count does not exceed the maximum.
//
// For example, in a two-person room with no single passenger price,
// a count of 2 adults is possible, and a count of 1 adult is a
// step along the way.
//
// Thus, in both of the above cases, return a count with two passengers.
//
// If no possible count can be reached from the current count by
// adding people (for example, the count has 3 adults in a two-person room),
// return null.
function findReachablePossibleCount(count, roomType, byRemoving, maxCount) {
    var possibleAssignments = roomType.PossiblePassengerAssignments;
    if (!possibleAssignments) {
        console.error('No possible assignments for room type:', roomType);
        // Default to true, backend will catch it if it's actually impossible.
        return true;
    }

    // Check if the given count is itself possible (the simple case).
    if (_.has(possibleAssignments, countToString(count))) {
        return count;
    }

    return findReachablePossibleDifferentCount(count, roomType, byRemoving, maxCount);
}

// As above, but the current count is not acceptable - the count found
// must have more (or less, if byRemoving = true) passengers.
function findReachablePossibleDifferentCount(count, roomType, byRemoving, maxCount) {
    var possibleAssignments = roomType.PossiblePassengerAssignments;

    // Find a possible valid assignment the current count may lead to.
    // For example, if the current count is one adult in a two-person room,
    // the possible valid assignment may be "2AC0I0" or "1A1CI0".
    var possibleTargetAssignment = _.find(_.keys(possibleAssignments), function (assignment) {
        var possibleCount = countFromAssignment(assignment);

        // If the maximum count is provided, make sure the target
        // count can be reached without going over the maximum.
        // This can be done by checking that the maximum count can
        // be reached from the target count.
        if (maxCount && !(countsEqual(possibleCount, maxCount) || countLeadsTo(possibleCount, maxCount))) {
            return false;
        }

        return countLeadsTo(count, possibleCount, byRemoving);
    });

    if (possibleTargetAssignment) {
        return countFromAssignment(possibleTargetAssignment);
    } else {
        return null;
    }
}

// Return true if the room cannot be booked for the passengers in _count_ but can be booked
// for a larger amount of passengers.
function roomIsTooLarge(count, roomType) {
    // Find possible count by removing passengers.
    var possibleCount = findReachablePossibleCount(count, roomType, true);
    if (possibleCount) {
        // The room can be booked for the passengers or a subset of them.
        return false;
    }
    var possibleCountWithMorePassengers = findReachablePossibleDifferentCount(count, roomType, false);
    if (possibleCountWithMorePassengers) {
        // The room could be booked for a larger number of passengers.
        return true;
    }
    // If we got here, the room cannot be booked for any number of passengers.
    var roomDesc = getRoomDesc(roomType);
    log.warn('Room', roomDesc, 'cannot be booked for ANY number of passengers.');
    return false;
}

// Return true if the counts are equal.
function countsEqual(a, b) {
    return a.adults === b.adults && a.children === b.children && a.infants === b.infants;
}

// Return true if passenger count B can be reached from A by adding
// more passengers or removing existing passengers. In other words,
// return true if A is a step along the way to B.
function countLeadsTo(a, b, byRemoving) {
    if (byRemoving) {
        return countLeadsTo(b, a, false);
    } else {
        return a.adults + a.children + a.infants < b.adults + b.children + b.infants && a.adults <= b.adults && a.children <= b.children && a.infants <= b.infants;
    }
}

function assignmentIsPossible(assignment, roomType) {
    var possibleAssignments = roomType.PossiblePassengerAssignments;
    if (!possibleAssignments) {
        console.error('No possible assignments for room type:', roomType);
        // Default to true, backend will catch it if it's actually impossible.
        return true;
    }
    return _.has(possibleAssignments, assignment);
}

// Return a string of the form "AnCnIn".
// Example: { adults: 2, children: 1, infants: 0 } => "A2C1I0"
// This is a lodash template that can be used like a function.
var countToString = _.template('A<%= adults %>C<%= children %>I<%= infants %>');

// Do the reverse of the above function.
function countFromAssignment(assignment) {
    return {
        adults: getCategoryCount('A', assignment),
        children: getCategoryCount('C', assignment),
        infants: getCategoryCount('I', assignment)
    };
}

function getCategoryCount(letter, s) {
    var start = s.indexOf(letter) + 1;
    if (start === 0) {
        throw new Error('Category ' + letter + ' not found in assignment string: ' + s);
    }
    var end = start + 1;
    while (end < s.length && isDigit(s[end])) {
        ++end;
    }
    var number = s.substring(start, end);
    var count = parseInt(number);
    if (isNaN(count)) {
        throw new Error('Invalid assignment string: ' + s);
    }
    return count;
}

function isDigit(c) {
    return !isNaN(parseInt(c));
}

function getRoomCheckboxes(roomType, roomNumber) {
    var boxes = getRoomTypeCheckboxes(roomType);
    if (boxes && boxes[roomNumber]) {
        return boxes[roomNumber];
    } else {
        // console.warn('[winresReservationCongressRooms getRoomCheckboxes] No room with index',
        // roomNumber);
        return [];
    }
}

function getRoomTypeCheckboxes(roomType) {
    var checkboxes = roomType.PassengerCheckboxes;
    if (!checkboxes) {
        console.warn('[winresReservationCongressRooms getRoomTypeCheckboxes] No checkboxes for room type:', roomType);
        return null;
    }

    // Convert array-like objects to arrays, since
    // _checkboxes_ seems to be of the following form:
    // [ { '0': true, '1': false }, { '0': false } ]
    return _.map(checkboxes, objectToArray);
}

// Convert an object with numeric string keys to an array.
function objectToArray(object) {
    var keys = _.keys(object);
    var array = new Array(keys.length);
    _.forEach(keys, function (key) {
        var index = _.toInteger(key);
        array[index] = object[key];
    });
    return array;
}

function hasCheckboxes(passengerCheckboxes) {
    if (!passengerCheckboxes) return false;
    return passengerCheckboxes.length > 0;
}

function getRoomDesc(room) {
    var di = room.DestinationInfo;
    var roomDesc = di && '' + di.DestinationCode + ' ' + di.ProductCode || '<Unknown>';
    return roomDesc;
}

// Smooth scroll to tabs.
// To do: move script outside component.
/*function scrollToTabs(){
    var tab = document.getElementsByTagName("winres-reservation-shopping-tabs")[0];
    if(tab) tab.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
}*/

WinresReservationCongressRoomsController.$inject = ['$scope', '$rootScope', '$filter', 'productService', 'departureService', 'reservationService', 'localizationService', 'cancelService', '$location', '$timeout'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils2.getWebcomponentsUrl)($attrs.templateUrl)) : 'congressRooms';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('congressRooms', require('./winresReservationCongressRooms.html'));
}]);

_module3.default.component('winresReservationCongressRooms', {
    templateUrl: getTemplate,
    controller: WinresReservationCongressRoomsController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        everyoneCanHaveOwnRoom: '@', // true or false (default), if everyone can be alone in room
        requireAllOrNoneAccommodated: '@', // 'true' or 'false' (default). If true, requires that either all passengers or no passengers are accommodated.
        requireAllAccommodated: '@', // 'true' or 'false' (default). If true, requires all users be accommodated.
        disallowExtraOccupancy: '@', // 'true' or 'false' (default). If true, does not allow booking of extra rooms.
        departureMode: '@', // 'normal' - Default. current departure comes from outside of this component, e.g. URL
        // 'show-all' - K&K: multiple departures shown simultaneusly and accommodations from them may be mixed.
        // 'dropdown' - K&K: user selects departure from a dropdown.
        departureCodes: '@', // overrides the destination code that comes from data. Supports multiple codes, separate with comma (,)
        showAlways: '@',
        dropdown: '@', // If 'true', room number is selected from a dropdown instead of "Add" and "Remove" buttons.
        showContinueButton: '@',
        assignCabins: '@', // 'inline' (default) or 'false'
        defaultPplToRooms: '@', // If set to 'true' a room will be selected automatically and passengers are set to that room. If not set to 'true', the user has to select room manually. Currently works with 1 or 2 ppl to 1 room.
        activePrice: '@', // true / false (default) makes the price in element "p.room-title" to change to current price
        fullWidthHotel: '@',
        listOnly: '@',
        showFullWithMessage: '@',
        hideImages: '@', // Hide rooms image.
        hideName: '@' // Hide rooms producer company name.
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationCongressRooms/winresReservationCongressRooms.js
// module id = 375
// module chunks = 2